<template>
  <div class="space-y-8">
    <BlogBlockView
      v-for="block in visible"
      :key="block.id"
      :block="block"
      :device="device"
      :preview="preview"
    />
    <div
      v-if="gated.length && !unlocked"
      class="relative"
    >
      <div class="pointer-events-none select-none blur-sm">
        <BlogBlockView
          v-for="block in gated"
          :key="block.id"
          :block="block"
          :device="device"
          :preview="preview"
        />
      </div>
      <div class="absolute inset-0 flex items-end justify-center bg-gradient-to-t from-[var(--arad-surface)] via-[var(--arad-surface)]/80 to-transparent p-6">
        <form
          class="w-full max-w-sm space-y-3 rounded-2xl border border-[var(--ui-border)] bg-[var(--arad-surface)] p-4 shadow-lg"
          @submit.prevent="submit"
        >
          <p class="text-center text-sm font-medium">
            برای ادامه مطالعه شماره موبایل را وارد کنید.
          </p>
          <AuthPhoneInput v-model="phone" />
          <UInput
            v-if="otpSent"
            v-model="code"
            dir="ltr"
            maxlength="6"
            placeholder="کد ۶ رقمی"
          />
          <UButton
            type="submit"
            block
            :loading="saving"
            :disabled="!canSubmit"
          >
            {{ otpSent ? 'تأیید و ادامه' : 'ارسال کد' }}
          </UButton>
          <UButton
            v-if="mode === 'soft'"
            type="button"
            variant="ghost"
            color="neutral"
            block
            @click="unlock"
          >
            فعلاً رد می‌کنم
          </UButton>
          <p
            v-if="error"
            class="text-center text-sm text-error"
          >
            {{ error }}
          </p>
        </form>
      </div>
    </div>
    <template v-else>
      <BlogBlockView
        v-for="block in gated"
        :key="block.id"
        :block="block"
        :device="device"
        :preview="preview"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { BlogBlock, BlogPreviewDevice } from '~/types/blog'
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import { splitGatedContent } from '~/utils/leads/gate'
import { blockPlainText } from '~/utils/blog/plainText'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  content: BlogBlock[]
  percentage: number
  mode: 'soft' | 'hard'
  slug?: string
  device?: BlogPreviewDevice
  preview?: boolean
}>()

const unlocked = ref(false)
const phone = ref('')
const code = ref('')
const otpSent = ref(false)
const saving = ref(false)
const error = ref('')

const split = computed(() => splitGatedContent<BlogBlock>(
  props.content,
  props.percentage,
  (block) => blockPlainText(block).length,
))
const visible = computed(() => split.value.visible)
const gated = computed(() => split.value.gated)
const canSubmit = computed(() => isCompleteIrMobile(phone.value) && (!otpSent.value || code.value.length === 6))
function unlock() {
  unlocked.value = true
}

async function submit() {
  if (!canSubmit.value || props.preview) return
  saving.value = true
  error.value = ''
  try {
    if (!otpSent.value) {
      await $fetch('/api/leads/blog-gate/otp', { method: 'POST', body: { phone: phone.value } })
      otpSent.value = true
    }
    else {
      await $fetch('/api/leads/blog-gate/verify', {
        method: 'POST',
        body: { phone: phone.value, code: code.value, slug: props.slug },
      })
      unlocked.value = true
    }
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'تأیید ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
